function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "a89e9461-9f2f-41d9-9fbb-6b13233bc0ba",
  "data-name": "Admin"
}, /*#__PURE__*/React.createElement("g", {
  id: "b7d6e1b6-02e2-4aa0-b2ee-77c6b8dba06d",
  "data-name": "admin userverwaltung"
}, /*#__PURE__*/React.createElement("path", {
  id: "e9a619e2-5c11-492e-83f8-2b9398fa1386",
  "data-name": "Fill-9",
  className: "a9f42c94-b3ba-42ae-ae3a-d879657c0ce5",
  d: "M18.09,11.87a.72.72,0,0,1,.6-.44h2.62a.72.72,0,0,1,.6.44l.16.56H17.93Zm8.34,3a.72.72,0,0,1,.7.74h0l-.54,12.58A1.94,1.94,0,0,1,24.65,30h-9.3a1.94,1.94,0,0,1-1.94-1.82h0L12.87,15.6a.73.73,0,0,1,1.46-.06h0l.53,12.58a.49.49,0,0,0,.49.45h9.3a.49.49,0,0,0,.49-.45h0l.53-12.58A.72.72,0,0,1,26.43,14.86ZM20,16.14a.58.58,0,0,1,.58.57h0v9.72a.58.58,0,0,1-1.16,0h0V16.71A.58.58,0,0,1,20,16.14Zm-3.22,0a.58.58,0,0,1,.6.56h0l.29,9.71a.57.57,0,0,1-.56.59h0a.57.57,0,0,1-.58-.55h0l-.29-9.72A.58.58,0,0,1,16.78,16.14Zm6.44,0a.58.58,0,0,1,.56.59h0l-.29,9.72a.57.57,0,0,1-.58.55h0a.57.57,0,0,1-.56-.59h0l.29-9.71A.59.59,0,0,1,23.22,16.14ZM21.31,10a2.14,2.14,0,0,1,2,1.48h0l.27.95h3.69a.72.72,0,1,1,0,1.43H12.73a.72.72,0,1,1,0-1.43h3.69l.27-.95a2.14,2.14,0,0,1,2-1.48h2.62Z"
})));

var SvgIconBin = function SvgIconBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bin.e716a6b4.svg";
export { ForwardRef as ReactComponent };